import { create } from "zustand";

type Status = "Pending" | "Approved" | "Rejected" | "Cancelled";

interface HookProps {
  filter: Status;
  setFilter: (filter: Status) => void;
}

export const useStatusFilter = create<HookProps>()((set) => ({
  filter: "Pending",
  setFilter: (filter) =>
    set(() => ({
      filter,
    })),
}));
